import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';
import * as api from '../api/station-tools-api';
import { RootState } from './reducers';

export const RAMP_SERVICES_GET = 'RAMP_SERVICES_GET';

export const getRampServices = (): ThunkAction<Promise<void>, RootState, unknown, AnyAction> => async dispatch => {
  try {
    const services = await api.getRampServices();
    dispatch({ type: RAMP_SERVICES_GET, payload: { services } });
  } catch (err) {
    throw err;
  }
};
